import { Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { BrowserMultiFormatReader, IScannerControls } from '@zxing/browser';
import {
  ScanLocation,
  WarehouseLocationModel,
} from '../../../../../modules/warehouse-management/features/locations/models/location.models';
import { LocationService } from '../../../../../modules/warehouse-management/features/locations/services/location-api.service';
import { BaseUserModel } from '../../../../models/baseUser.model';
import { ErrorHandlerService } from '../../../../services/error-handler.service';
import { ToasterService } from '../../../../services/toaster.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-scan-location',
  standalone: false,
  templateUrl: './scan-location.component.html',
  styleUrl: './scan-location.component.css',
})
export class ScanLocationComponent implements OnDestroy {
  constructor(
    private userService: UserService,
    private readonly toaster: ToasterService,
    private errorService: ErrorHandlerService,
    private readonly warehouseLocationApiService: LocationService,
  ) {}

  userDetails: BaseUserModel = new BaseUserModel();
  verifyLocation: ScanLocation = new ScanLocation();
  barcode: string = '';
  @ViewChild('video') videoElementRef!: ElementRef<HTMLVideoElement>;
  @Output() scannedLocation = new EventEmitter<WarehouseLocationModel>();

  async ngOnInit() {
    const user = await this.userService.getUserFromLocalStorage(); // Assuming companyId is a property of user
    if (user) {
      this.userDetails = user;
    } else {
      // Handle the case where user is null
      this.toaster.error('User details not found');
    }
  }
  // Barcode scanner variables and methods
  result: string | null = null;
  scanning = false;

  private readonly codeReader = new BrowserMultiFormatReader();
  private stream: MediaStream | null = null;
  private videoElement: HTMLVideoElement | null = null;
  private controls: IScannerControls | null = null;

  async toggleScan() {
    if (this.scanning) {
      this.stopScan();
    } else {
      this.scanning = true;
      setTimeout(() => {
        this.startScan();
      });
    }
  }

  private async startScan() {
    this.videoElement = this.videoElementRef.nativeElement;
    this.result = null;

    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });

      this.videoElement.srcObject = this.stream;

      // safer playback
      await this.videoElement.play().catch(() => {});

      this.controls = await this.codeReader.decodeFromVideoDevice(
        undefined,
        this.videoElement,
        (result, err) => {
          if (result) {
            this.barcode = result.getText();
            this.checkWarehouseLocation();
            this.result = null; // reset result to allow further scans
            this.stopScan();
          }
        },
      );
    } catch (error) {
      console.error('Camera error:', error);
      this.scanning = false;
    }
  }
  checkWarehouseLocation() {
    this.verifyLocation.name = this.barcode;
    this.verifyLocation.companyId = Number(this.userDetails.companyId);
    this.verifyLocation.warehouseId = Number(this.userDetails.imsDefaultWarehouseId);
    this.warehouseLocationApiService.ValidateScanLocation(this.verifyLocation).subscribe({
      next: (data: any) => {
        this.toaster.success('Location Validation Successful');
        this.scannedLocation.emit(data);
      },
      error: (err) => {
        this.errorService.handleApiError(err);
      },
    });
  }

  private stopScan() {
    if (this.controls) {
      this.controls.stop();
      this.controls = null;
    }

    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
      this.stream = null;
    }

    if (this.videoElement) {
      this.videoElement.style.display = 'none';
    }

    this.scanning = false;
  }

  ngOnDestroy() {
    this.stopScan();
  }
}
